var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sidebar-demo"}},[_c('sidebar-default'),_c('sidebar-parent'),_c('sidebar-static'),_c('sidebar-group-collapsed'),_c('sidebar-right'),_c('sidebar-reduce-expand'),_c('sidebar-custom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }